// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"67e6bf87","977":"08460cd6"}[chunkId] + ".chunk.js";
};